import { useAuth } from "@lib/auth/useAuth";
import { ACTIVE_CONSENTS_TYPE } from "@lib/constants/consents";
import { getRouteFromRoutesFile } from "@lib/constants/pagePaths";
import rootRoutes from "@pages/_routes.json";
import { useGetMyProfile } from "@store/hooks";

type Config = {
    locale: string;
    asPath: string;
};

export const useHideEmailForm = ({ locale, asPath }: Config) => {
    const { isAuthenticated } = useAuth();
    const { data } = useGetMyProfile();

    const hasConsent = data?.activeConsentTypes?.includes(ACTIVE_CONSENTS_TYPE.NEWSLETTER);

    const createAccountPage = getRouteFromRoutesFile(rootRoutes, "create-account");

    const pagesToHideForm = [createAccountPage[locale], createAccountPage["en"]].filter(Boolean);
    const shouldHideOnPage = pagesToHideForm.some((path) => asPath.includes(path));

    const hideFromAuthenticatedUserWithConsent = hasConsent && isAuthenticated;

    return shouldHideOnPage || hideFromAuthenticatedUserWithConsent;
};
